export default __webpack_public_path__ + "media/images/google_logo-64742f6405be8486218c501395b08ccb.svg";